import Page from "@/components/Page";
import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <Page>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <Link to="/" className="text-sm" style={{ color: "#475569" }}>← Back</Link>
        <h1 className="font-serif text-3xl sm:text-4xl mt-3" style={{ color: "#0B2D59" }}>Privacy Notice</h1>
        <div className="p2p-card p-6 sm:p-8 mt-6 space-y-4" style={{ color: "#1F2937" }}>
          <p><strong>Your information stays with this housing provider.</strong> We use the information you share only to evaluate your rental application and to operate the property. We do not sell or share applicant information.</p>
          <h2 className="font-serif text-xl mt-4" style={{ color: "#0B2D59" }}>What we collect</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Contact information you provide</li>
            <li>Information about your current housing and your need for housing</li>
            <li>Lawful income and verification documents you choose to upload</li>
            <li>References that you provide</li>
            <li>Your voluntary &ldquo;Your Story&rdquo; responses</li>
          </ul>
          <h2 className="font-serif text-xl mt-4" style={{ color: "#0B2D59" }}>What we do not ask for</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>A Social Security number on the initial application</li>
            <li>Diagnosis or medical information</li>
            <li>Children&apos;s ages or family-status details beyond occupancy count</li>
            <li>Criminal or arrest history (no criminal background check is required)</li>
          </ul>
          <h2 className="font-serif text-xl mt-4" style={{ color: "#0B2D59" }}>How AI is used</h2>
          <p>Artificial intelligence may help organize and summarize the information you provide. AI will not make the final rental decision. A person will review every completed application. AI does not infer protected characteristics and will not score your story.</p>
          <h2 className="font-serif text-xl mt-4" style={{ color: "#0B2D59" }}>Security</h2>
          <p>Data is encrypted in transit. Access to applicant data is role-based and protected by administrator authentication with a second factor. An access and activity log is maintained.</p>
          <h2 className="font-serif text-xl mt-4" style={{ color: "#0B2D59" }}>Your choices</h2>
          <p>You may pause and resume your application, request withdrawal, or request deletion of a withdrawn or rejected application when legally permitted. Email apply@pathways2purpose.local.</p>
          <p className="encourage text-sm">Equal Housing Opportunity. This housing provider does not discriminate on the basis of any federally or state-protected characteristic.</p>
        </div>
      </div>
    </Page>
  );
}
